import styled from "@emotion/styled";
import React from "react";
import { MergeWithOverwrite } from "src/common";
import { colors } from "src/theme";

const IconSpan = styled.span((props: { height: number, width: number }) => ({
  display: 'inline-flex',
  height: props.height,
  width: props.width,
}))

export type CardIconProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLSpanElement>, {
  width?: number,
  height?: number,
  color?: string,
}>;

export const CardIcon: React.FC<CardIconProps> = ({ width = 16, height = 12, color = colors.primary, ...props }) => (
  <IconSpan {...props} height={height} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 12" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M1 1.5C1 1.22414 1.22414 1 1.5 1H14.5C14.7759 1 15 1.22414 15 1.5V4H1V1.5ZM0 4.5V1.5C0 0.671858 0.671858 0 1.5 0H14.5C15.3281 0 16 0.671858 16 1.5V4.5V10.5C16 11.3281 15.3281 12 14.5 12H1.5C0.671858 12 0 11.3281 0 10.5V4.5ZM15 5V10.5C15 10.7759 14.7759 11 14.5 11H1.5C1.22414 11 1 10.7759 1 10.5V5H15ZM3.5 8C3.22386 8 3 8.22386 3 8.5C3 8.77614 3.22386 9 3.5 9H6.5C6.77614 9 7 8.77614 7 8.5C7 8.22386 6.77614 8 6.5 8H3.5ZM11.5 8C11.2239 8 11 8.22386 11 8.5C11 8.77614 11.2239 9 11.5 9H12.5C12.7761 9 13 8.77614 13 8.5C13 8.22386 12.7761 8 12.5 8H11.5Z" fill={color} />
    </svg>
  </IconSpan>
);
